// extracted by css-extract-rspack-plugin
export default {"CheckModalContainer":"CheckModalContainer-laFC9I","checkModalContainer":"CheckModalContainer-laFC9I"};